//const API_BASE_URL = "https://localhost:44303/api";
const API_BASE_URL = "https://beapi.factbazaar.com/api";

export default API_BASE_URL;
